import * as React from "react";
import type { SVGProps } from "react";

const SvgExpenseWalletIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={113}
    height={98}
    viewBox="0 0 113 98"
    {...props}
  >
    <defs>
      <path id="expense-wallet-icon_svg__a" d="M0 0h113v98H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <mask id="expense-wallet-icon_svg__b" fill="#fff">
          <use xlinkHref="#expense-wallet-icon_svg__a" />
        </mask>
        <path
          fill="#142745"
          d="M108.479 64.797c0 3.02-2.462 5.479-5.488 5.479H79.745c-5.162 0-9.362-4.193-9.362-9.348 0-5.154 4.2-9.347 9.362-9.347h19.371c2.464 0 4.386-1.13 5.413-3.182q.148-.296.257-.584c3.693.48 3.693 2.59 3.693 5.377zm-98.47 28.688c-3.026 0-5.487-2.457-5.487-5.479V28.371h96.208v17.073c-.014.426-.075 1.622-1.614 1.622h-19.37c-7.656 0-13.884 6.219-13.884 13.862 0 7.644 6.228 13.862 13.883 13.862h20.985v18.695zm-.497-75.957a2 2 0 0 0 .167-.022L85.233 4.923v18.933H4.522v-.871a5.456 5.456 0 0 1 4.99-5.457m95.74 25.81V26.114a2.26 2.26 0 0 0-2.261-2.258H89.755V2.257A2.256 2.256 0 0 0 87.122.031L9.014 13.041A9.95 9.95 0 0 0 0 22.984v65.021C0 93.516 4.49 98 10.01 98h92.98a2.26 2.26 0 0 0 2.262-2.257V74.53c4.433-1.026 7.748-5 7.748-9.733V53.192c0-2.745-.006-8.868-7.748-9.854"
          mask="url(#expense-wallet-icon_svg__b)"
        />
      </g>
      <path fill="#142745" d="M81.5 58a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7" />
    </g>
  </svg>
);
export default SvgExpenseWalletIcon;
